import _ from 'lodash'
import Vue from 'vue'
import Settings from '@/config/Settings'

export default {

  namespaced: true,
  state: {
    // initialized: false,
  },
  mutations:{
  },
  getters: {
    // initialized: state => state.initialized,
  }
}
